/* ============================================================================
   Minicart · carrusel de complementarios / más populares (patrón VANS)
   ----------------------------------------------------------------------------
   - Lee el contenedor [data-hp-cart-recs] de sections/cart-drawer.liquid
     (modo, productos de origen, productos a excluir, intent y límite).
   - Pide las tarjetas a la Section Rendering API
     (sections/hp-cart-recommendations.liquid):
       · data-mode="cart": recomendaciones de los productos del carrito; primero
         "complementary" y, si no hay ninguna configurada en Search & Discovery,
         "related".
       · data-mode="popular" (carrito vacío): la colección de data-url, que por
         defecto es /collections/all ordenada por más vendidos.
   - Carga perezosa: solo cuando el minicart se abre. Canopy re-renderiza todo el
     drawer en cada cambio (theme.updateCartSummaries), así que las respuestas se
     cachean por producto y el carrusel se vuelve a montar sin otra petición.
   - "Agregar": POST /cart/add.js, evento GA4 add_to_cart y refresco del drawer.
   ============================================================================ */
(function () {
  'use strict';

  if (window.__hpCartRecs) return;
  window.__hpCartRecs = true;

  var SECTION_ID = 'hp-cart-recommendations';
  var ROOT = '[data-hp-cart-recs]';
  var cache = {};

  function rootUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function splitIds(value) {
    return String(value || '').split(',').filter(Boolean);
  }

  // --- Datos -----------------------------------------------------------------
  function withSection(url) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + SECTION_ID;
  }

  function fetchCards(requestUrl) {
    var key = requestUrl;
    if (!cache[key]) {
      cache[key] = fetch(requestUrl, { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.map.call(doc.querySelectorAll('.hp-cart-recs__item'), function (el) {
            return { id: el.getAttribute('data-product-id'), html: el.outerHTML };
          });
        })
        .catch(function () {
          delete cache[key];
          return [];
        });
    }
    return cache[key];
  }

  function fetchItems(url, productId, intent, limit) {
    return fetchCards(withSection(url) + '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + limit + '&intent=' + intent);
  }

  // Mezcla las listas de cada producto del carrito (1º de cada una, 2º de cada una...).
  function interleave(lists) {
    var out = [];
    var max = 0;
    lists.forEach(function (list) { if (list.length > max) max = list.length; });
    for (var i = 0; i < max; i++) {
      lists.forEach(function (list) { if (list[i]) out.push(list[i]); });
    }
    return out;
  }

  function gather(url, ids, intent, limit) {
    return Promise.all(ids.map(function (id) { return fetchItems(url, id, intent, limit); }))
      .then(interleave);
  }

  // --- Montaje -----------------------------------------------------------------
  function mount(root) {
    if (root.__hpMounted) return;
    root.__hpMounted = true;

    var url = root.getAttribute('data-url');
    var popular = root.getAttribute('data-mode') === 'popular';
    var ids = splitIds(root.getAttribute('data-product-ids'));
    var exclude = splitIds(root.getAttribute('data-exclude-ids'));
    var intent = root.getAttribute('data-intent') === 'related' ? 'related' : 'complementary';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 8;
    if (!url || (!popular && !ids.length)) return;

    var request = popular
      ? fetchCards(withSection(url))
      : gather(url, ids, intent, limit).then(function (items) {
        if (!items.length && intent === 'complementary') return gather(url, ids, 'related', limit);
        return items;
      });

    request
      .then(function (items) {
        var seen = {};
        var finalItems = items.filter(function (item) {
          if (!item.id || seen[item.id] || exclude.indexOf(item.id) !== -1) return false;
          seen[item.id] = true;
          return true;
        }).slice(0, limit);

        if (!root.isConnected || !finalItems.length) return;

        var track = root.querySelector('[data-hp-recs-track]');
        track.innerHTML = finalItems.map(function (item) { return item.html; }).join('');
        root.hidden = false;
        track.addEventListener('scroll', function () { updateArrows(root); }, { passive: true });
        updateArrows(root);
      });
  }

  function mountAll() {
    Array.prototype.forEach.call(document.querySelectorAll(ROOT), mount);
  }

  // --- Navegación ----------------------------------------------------------------
  function stepWidth(track) {
    var card = track.querySelector('.hp-cart-recs__item');
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateArrows(root) {
    var track = root.querySelector('[data-hp-recs-track]');
    var nav = root.querySelector('.hp-cart-recs__nav');
    var prev = root.querySelector('[data-hp-recs-prev]');
    var next = root.querySelector('[data-hp-recs-next]');
    if (!track) return;
    var maxScroll = track.scrollWidth - track.clientWidth - 2;
    if (nav) nav.hidden = maxScroll <= 0;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= maxScroll;
  }

  // --- Agregar al carrito ---------------------------------------------------------
  function trackAddToCart(root, btn, source, priceCents) {
    var price = (Number(priceCents) || 0) / 100;
    var variantTitle = source.getAttribute('data-title');
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      var popular = root.getAttribute('data-mode') === 'popular';
      window.dataLayer.push({
        event: 'add_to_cart',
        hp_source: popular ? 'cart_popular' : 'cart_recommendations',
        ecommerce: {
          currency: root.getAttribute('data-currency') || undefined,
          value: price,
          items: [{
            item_id: btn.getAttribute('data-product-id'),
            item_name: btn.getAttribute('data-product-title'),
            item_brand: btn.getAttribute('data-product-vendor') || undefined,
            item_variant: variantTitle && variantTitle !== 'Default Title' ? variantTitle : undefined,
            item_list_name: popular ? 'Minicart - más populares' : 'Minicart - complementarios',
            price: price,
            quantity: 1
          }]
        }
      });
    } catch (e) { /* la analítica nunca bloquea la compra */ }
  }

  function addToCart(btn) {
    var root = btn.closest(ROOT);
    var card = btn.closest('.hp-cart-recs__item');
    var input = card && card.querySelector('[data-hp-recs-variant]');
    if (!root || !input) return;

    var variantId = input.value;
    if (!variantId) {
      input.classList.add('is-error');
      input.focus();
      setTimeout(function () { input.classList.remove('is-error'); }, 1500);
      return;
    }

    var source = input.tagName === 'SELECT' ? input.options[input.selectedIndex] : input;
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/add ' + response.status);
        trackAddToCart(root, btn, source, source.getAttribute('data-price'));
        if (window.theme && typeof window.theme.updateCartSummaries === 'function') {
          window.theme.updateCartSummaries(true, true);
        } else {
          window.location.href = rootUrl() + 'cart';
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.textContent = 'Reintentar';
      });
  }

  // --- Eventos -------------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-hp-recs-prev], [data-hp-recs-next]');
    if (arrow) {
      var root = arrow.closest(ROOT);
      var track = root && root.querySelector('[data-hp-recs-track]');
      if (track) {
        var direction = arrow.hasAttribute('data-hp-recs-prev') ? -1 : 1;
        track.scrollBy({ left: direction * stepWidth(track), behavior: 'smooth' });
      }
      return;
    }

    var addBtn = e.target.closest('[data-hp-recs-add]');
    if (addBtn) {
      e.preventDefault();
      addToCart(addBtn);
    }
  });

  // Montar solo con el minicart abierto (y volver a montar cuando Canopy lo re-renderiza).
  function checkOpen() {
    if (document.body.classList.contains('show-cart-summary')) mountAll();
  }

  new MutationObserver(checkOpen).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  var drawerHost = document.querySelector('[data-section-type="cart-drawer"]');
  if (drawerHost) new MutationObserver(checkOpen).observe(drawerHost, { childList: true });
  document.addEventListener('shopify:section:load', checkOpen);
  checkOpen();
})();
